import { Location } from "@commutifi-fe/interfaces";
import { useAsync } from "./useAsync";

interface IBrowserLocationOptions {
  shouldFetch?: boolean;
}

/**
 * Get the user location from the navigator geolocation API
 *
 * @returns {Promise<Location>} Location from browser
 */
export const getUserLocation = (): Promise<Location> => {
  const geolocationService = navigator.geolocation;

  return new Promise((resolve, reject) => {
    geolocationService.getCurrentPosition(
      (results) =>
        resolve({
          lat: results.coords.latitude,
          lng: results.coords.longitude,
        }),
      (error) => reject(error)
    );
  });
};

export const useBrowserLocation = ({
  shouldFetch = false,
}: IBrowserLocationOptions) =>
  useAsync<Location | undefined>(async () => {
    if (!shouldFetch) {
      return;
    }
    const location = await getUserLocation();
    return location;
  }, [shouldFetch]);
